import Button from 'components/_parts/atoms/button';
import Label from 'components/_parts/atoms/label';
import React from 'react';

function Index(props) {
  const { handleDelete } = props;
  return (
    props?.data?.map((val, index) => (
      <div
        className={`custom_layout_list ${props?.className}`}
        style={props?.style}
      >
        {props?.type === 'delete' ? (
          <>
            <Label style={{ width: '64%' }}>
              {val?.competency_set ? `${val.competency_set} -` : ''}
              {' '}
              {val?.competency_type}
              {' '}
              -
              {val?.competency_level}
            </Label>
            <Button
              style={{
                backgroundColor: '#FE493D',
                width: '26px',
                height: '26px',
              }}
              icon="delete"
              func={() => props?.handleDeleteComp(val, index)}
            />
          </>
        ) : props?.type === 'createBp' ? (
          <>
            <Label style={{ width: '64%' }}>{val?.title}</Label>
            <Button
              style={{
                backgroundColor:
                    val.type === 'primary'
                      ? '#2E9CFF'
                      : val.type === 'steering'
                        ? '#79FF39'
                        : val.type === 'support'
                          ? '#FFDF32'
                          : 'transparent',
                height: '20px',
                padding: '0px 20px',
                fontWeight: '600',
              }}
            >
              {val?.type}
            </Button>
            <Button
              style={{ width: '24px', height: '24px' }}
              icon="create"
            />
          </>
        ) : props?.type === 'deleteBp' ? (
          <>
            <Label style={{ width: '64%' }}>{val?.title}</Label>
            <Button
              style={{
                backgroundColor:
                    val.type === 'primary'
                      ? '#2E9CFF'
                      : val.type === 'steering'
                        ? '#79FF39'
                        : val.type === 'support'
                          ? '#FFDF32'
                          : 'transparent',
                height: '20px',
                padding: '0px 20px',
                fontWeight: '600',
              }}
            >
              {val?.type}
            </Button>
            <Button
              style={{
                width: '24px',
                height: '24px',
                backgroundColor: '#FE493D',
              }}
              icon="delete"
            />
          </>
        ) : props?.type === 'deleteWorkload' ? (
          <React.Fragment key={val.value}>
            <div className="deleteWorkload">
              <Label>
                {val?.activity_name}
                {' '}
              </Label>
              {' '}
              -
              <Label>{val?.standart_waktu}</Label>
            </div>
            <Button
              style={{
                backgroundColor: '#FE493D',
                width: '26px',
                height: '26px',
              }}
              icon="delete"
              func={() => handleDelete(val, index)}
            />
          </React.Fragment>
        ) : (
          ''
        )}
      </div>
    ))
  );
}

export default Index;
